// Dependencies
import { FC, ReactElement } from "react";

// Components
import FormErrorMessage from "~/components/Common/FormErrorMessage";

// Styles
import {
  StyledFormItem,
  StyledItemData,
  StyledRequiredSign,
} from "./Form.styled";
import { StyledItemLabel } from "~/components/Layout/InfoItem/InfoItem.styled";

interface FormItemProps {
  label: string;
  formItem: ReactElement;
  htmlFor: string;
  hasError?: boolean;
  error?: string | undefined;
  required?: boolean;
}

const FormItem: FC<FormItemProps> = ({
  label,
  formItem,
  htmlFor,
  hasError = false,
  error,
  required,
}) => {
  return (
    <StyledFormItem>
      <StyledItemData>
        <StyledItemLabel key={1} component="label" htmlFor={htmlFor}>
          {label} {required && <StyledRequiredSign />}
        </StyledItemLabel>
        <div key={2}>{formItem}</div>
      </StyledItemData>
      <FormErrorMessage hasError={hasError} error={error} />
    </StyledFormItem>
  );
};

export default FormItem;
